import { RootState } from '../../rootReducer';
// Types
import { ILanguageState } from './types';

export const selectLanguageState = (state: RootState): ILanguageState => state.language;
